import { useAppSelector } from "app/hook";
import AddAndUpdateStudent from "pages/dashboard/shared/Users/Students/Add&UpdateStudentForm";

const UpdateStudent = () => {
  const { uid } = useAppSelector(({ auth }) => auth);

  return (
    <AddAndUpdateStudent
      redirectTo="/school/dashboard/users/student"
      schoolId={uid ?? ""}
      isUpdate={true}
    />
  );
};

export default UpdateStudent;
